import { defineAction } from '~/prix'
import { z } from 'zod'
import materialUpdateAction from './materialUpdate.action.json' with { type: 'json' }
import { materialObject } from '../materialObject'

const materialUpdateDefinition = defineAction({
  ...materialUpdateAction,
  input: materialObject
    .pick({
      id: true,
      name: true,
      type: true,
      description: true,
      buyDate: true,
      noteNumber: true,
      supplier: true,
    })
    .partial()
    .required({ id: true }),
  output: z.object({}),
})

export default materialUpdateDefinition
